'use client';

import { useEffect, useState } from 'react';

/** Whether the first element matching `selector` is in the viewport; false until it is found. */
export function useInView(selector: string): boolean {
    const [inView, setInView] = useState(false);

    useEffect(() => {
        const element = document.querySelector(selector);
        if (!element) return;

        const observer = new IntersectionObserver(([entry]) => setInView(entry.isIntersecting));
        observer.observe(element);

        return () => observer.disconnect();
    }, [selector]);

    return inView;
}
